module.exports = __webpack_public_path__ + "static/media/ic-emails.62ef1647.svg";